import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SeriesList from "../../Images/Cricket-Pages/Heading Icons/series list-min.webp";
import { getFetchSeriesList } from "../../redux/CricketApi/actions";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import AdBanner from "../../Components/AdBanner";
import { useBanners } from "../../Api/api";

const Series = () => {
  const dispatch = useDispatch();
  const { series_list } = useSelector((state) => state.CricketReducer);

  const [activeSeriesList, setActiveSeriesList] = useState();
  const [getAllMatchesList, setGetAllMatchesList] = useState(true);

  const { horizontal} = useBanners();


  useEffect(() => {
    if (!series_list || series_list.length === 0) {
      dispatch(getFetchSeriesList(activeSeriesList));
    }
    // console.log("series_list - ", series_list);

  }, [series_list, dispatch, activeSeriesList]); // Include activeSeriesList in dependency array

  const filteredMatches = series_list.filter(
    (match) => match.series_type === activeSeriesList
  );
  // console.log("filteredMatches - ", filteredMatches);

  const groupMatchesByDate = (matches) => {
    return matches.reduce((acc, match) => {
      // console.log("match - ", match);
      // console.log("acc - ", acc);
      const date = match.date_wise;
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(match);
      return acc;
    }, {});
  };

  let matchesGroupedByDate = groupMatchesByDate(filteredMatches);
  if (getAllMatchesList) {
    matchesGroupedByDate = groupMatchesByDate(series_list);
  }
  // console.log("matchesGroupedByDate - ", matchesGroupedByDate);

  const formatUrl = (url) => {
    const parts = url.split("/"); // Split URL into parts
    const lastPart = parts.pop(); // Get the last part that needs formatting

    const formattedPart = lastPart
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/[^a-z0-9\-]/g, ""); // Remove special characters except "-"

    return [...parts, formattedPart].join("/"); // Rebuild the URL
  };

  return (
    <>
      <Helmet>
        <title>
          Match Series Coverage | Latest Updates & Analysis at
          cricketbettingtips
        </title>
        <meta
          name="description"
          content="Get in-depth coverage of the latest match series at cricket betting tips. Stay updated with live scores, expert analysis, and detailed match reports on all your favorite sports."
        />
      </Helmet>
      <div className="xl:w-[90%] w-[95%] mx-auto px-2 my-10 py-7">
        <div
          className="rounded-lg py-3 mb-5 bg-[#215DA5]"
        >
          <h1 className="text-white md:text-[30px] text-[24px] font-semibold px-4 flex items-center justify-center gap-x-4 mb-0">
            <img
              src={SeriesList}
              alt="squads"
              className="w-[60px] border-2 rounded-full border-[#fff] p-2 bg-[#000]"
            />
            Series List
          </h1>
        </div>
        <div className="lg:space-x-4 space-x-2 pb-3 border-b-2 mb-4 border-[#dc9a2b12] match-type-tabs">
          <button
            onClick={() => {
              setGetAllMatchesList(true);
              setActiveSeriesList();
            }}
            className={`toggle-button info-hover bg-[#ffffff] text-[#000] md:px-6 px-[5px] py-2 rounded-[32px] font-[600] cursor-pointer ${getAllMatchesList ? "active" : ""
              }`}
          >
            All
          </button>
          <button
            onClick={() => {
              setActiveSeriesList("International");
              setGetAllMatchesList(false);
            }}
            className={`toggle-button info-hover bg-[#ffffff] border-bottom-[3px] text-[#000] md:px-6 px-[5px] py-2 rounded-[32px] font-[600] cursor-pointer ${activeSeriesList === "International" ? "active" : ""
              }`}
          >
            International
          </button>
          <button
            onClick={() => {
              setActiveSeriesList("Domestic");
              setGetAllMatchesList(false);
            }}
            className={`toggle-button info-hover bg-[#ffffff] border-bottom-[3px] text-[#000] md:px-6 px-[5px] py-2 rounded-[32px] font-[600] cursor-pointer ${activeSeriesList === "Domestic" ? "active" : ""
              }`}
          >
            Domestic & Others
          </button>
          <button
            onClick={() => {
              setActiveSeriesList("League");
              setGetAllMatchesList(false);
            }}
            className={`toggle-button info-hover bg-[#ffffff] border-bottom-[3px] text-[#000] md:px-6 px-[5px] py-2 rounded-[32px] font-[600] cursor-pointer ${activeSeriesList === "League" ? "active" : ""
              }`}
          >
            League
          </button>
          <button
            onClick={() => {
              setActiveSeriesList("Women");
              setGetAllMatchesList(false);
            }}
            className={`toggle-button info-hover bg-[#ffffff] border-bottom-[3px] text-[#000] md:px-6 px-[5px] py-2 rounded-[32px] font-[600] cursor-pointer ${activeSeriesList === "Women" ? "active" : ""
              }`}
          >
            Women
          </button>
        </div>

        {/* ==========Advertisement============== */}
        <div className="lg:mb-5 mb-[10px]">
          <AdBanner data={horizontal} type="horizontal" />
        </div>
        {Object.keys(matchesGroupedByDate).map((date) => (
          <div key={date} className="">
            <div className="flex md:mb-5 mb-[20px] justify-start items-center w-100 py-3 rounded-lg bg-[linear-gradient(90.3deg,#AF6B16_0.16%,#F8DF65_50.89%,#DC9A2B_101.62%)] px-3 text-left text-xl font-bold">
              <span className="lg:w-[200px] w-[150px] text-white">Month</span>{" "}
              {/* Display date */}
              <span className="text-white w-full ">Series Name</span>
            </div>
            {matchesGroupedByDate[date].map((match) => (
              <Link
                to={formatUrl(
                  `/series-details/${match.series_id}/${match.series}`
                )}
                key={match.series_id}
                className="text-white"
              >
                <div className="flex justify-start md:items-center md:gap-y-0 gap-y-5 flex-md-row flex-column w-100 md:py-2 py-3 bg-[#242424] hover:bg-[#393c3c] px-3 text-left md:mb-5 mb-[20px] rounded-lg">
                  <span className="lg:w-[200px] w-[150px] md:text-[16px] text-[20px] font-bold">
                    {match.month_wise}
                  </span>
                  <div className="flex flex-row w-full gap-x-[30px] items-center">
                    <img
                      src={match.image}
                      alt="series img"
                      className="md:w-[100px] w-[60px] rounded-full"
                    />
                    <div className="flex flex-col w-full">
                      <span className="text-[16px]">{match.series}</span>
                      <span className="text-[13px] text-[#ffffffaf]">
                        {match.series_date}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default Series;
